const state = () => ({
  owner: {
    familyName: "",
    givenName: "",
    photoVersion: 0,
    profilePhoto: false,
    username: "",
    email: ""
  },
  trackEmails: false,
  active: true,
  coApplicants: [{
    givenName: "",
    familyName: "",
    phone: "",
    email: "",
    id: ""
  }],
  customFields: [],
  label: {
    text: null,
    visible: false
  },
  collaborators: {
    byId: {},
    allIds: []
  },
  statusLabels: [],
  notifiedReferrers: {
    byId: {},
    allIds: []
  },
  timeline: {
    byId: {},
    allIds: []
  },
  timelineActivityLeft: 0,
  changelog: [],
  id: "",
  referrerId: "",
  givenName: "",
  familyName: "",
  labelText: "",
  labelColour: "",
  email: "",
  phoneNumber: "",
  value: "",
  status: "",
  cardColour: "",
  statusLabelId: "",
  followUpCount: "",
  noteCount: "",
  checklistCount: "",
  referrer: {
    givenName: "",
    familyName: ""
  },
  starredApplicationId: null,
  nextActionDate: null,
  updatedAt: "",
  createdAt: "",
  read: true,
  boardId: "",
  boardName: "",
  daysSinceLastActive: 0,
  daysSinceLastStatusChange: 0,
  reminders: [],
  subjectProperty: null,
  applicationFlow: null,
  linkedAccountUsername: null,
  dateOfBirth: null,
  masterUnsubscribed: null,
  authorUnsubscribed: null,
  participants: []
});
export default state;